module.exports = __webpack_public_path__ + "img/gold_50x50.de051fb9.png";